export default "__VITE_ASSET__BlSImduf__"